import axios, { type AxiosInstance } from "axios";

export type SiteType = "PF" | "PJ";
const SITE_TYPE_KEY = "@Admin:siteType";

export const setSiteType = (type: SiteType) =>
  localStorage.setItem(SITE_TYPE_KEY, type);

export const getSiteType = (): SiteType =>
  localStorage.getItem(SITE_TYPE_KEY) === "PJ" ? "PJ" : "PF";

export const apiPF = axios.create({
  baseURL: process.env.REACT_APP_APIURL,
});

export const apiPJ = axios.create({
  baseURL: process.env.REACT_APP_APIURL_PJ,
});

const applyInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (success) => success,
    (error) => {
      const err = error || {};
      console.log(err);
      const hasDetailError = err.response?.data?.hasOwnProperty?.("detail");
      const hasMessageError = err.response?.data?.hasOwnProperty?.("message");
      console.log(hasMessageError);

      if (hasDetailError) {
        const msg = err.response.data.detail ?? err.response.data.message;
        if (msg === "Token inválido.") {
          localStorage.removeItem("@Admin:token");
          localStorage.removeItem("@Admin:user");
          localStorage.removeItem("@Admin:siteType");
          window.location.reload();
        }
      } else if (hasMessageError) {
        const msg = err.response.data.message ?? err.response.data.message;
        console.log(msg);
        if (msg === "Token inválido.") {
          localStorage.removeItem("@Admin:token");
          localStorage.removeItem("@Admin:user");
          localStorage.removeItem("@Admin:siteType");
          window.location.reload();
        }
      }
      return Promise.reject(error);
    }
  );
};

applyInterceptors(apiPF);
applyInterceptors(apiPJ);

export const getApi = (type: SiteType = "PF"): AxiosInstance =>
  type === "PJ" ? apiPJ : apiPF;

export const getApiFromStorage = (): AxiosInstance => getApi(getSiteType());

export default getApi;
